module.exports = __webpack_public_path__ + "static/media/salto_logo.b580b857.svg";